// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.10.0",
  date: "2026-09-29T08:49:33.868Z",
  gitInfo: {
    dirty: false,
    raw: "2f7b8d5fd",
    hash: "2f7b8d5fd",
    distance: null,
    tag: null,
    semver: null,
    suffix: "2f7b8d5fd",
    semverString: null
  }
};
/* tslint:enable */
